import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import styles from './styles.module.css';

class SimpleRadioButton extends React.PureComponent {

  render() {

    const flex = this.props.flex === 'column' ? styles.radioInputColumn : styles.radioInputRow;

    return (
      <div
        className={`form_radio_${this.props.index}_${this.props.idx}_${this.props.sectionId} ${flex}`}
      >
        <input
          id={`radioOptionGroup_${this.props.index}_${this.props.idx}_${this.props.sectionId}`}
          type="radio"
          name={`radioOptionGroup_${this.props.index}_${this.props.sectionId}`}
          className={this.props.flex === 'column' ? styles.inputOptionColumn : styles.inputOptionRow}
          data-index={this.props.idx}
          value={this.props.value}
        />
        <label htmlFor={`radioOptionGroup_${this.props.index}_${this.props.idx}_${this.props.sectionId}`}>
          {this.props.value}
        </label>
      </div>
    );

  }

}

SimpleRadioButton.propTypes = {
  value: PropTypes.string,
  index: PropTypes.number,
  idx: PropTypes.number,
  sectionId: PropTypes.string,
  flex: PropTypes.string,
};

export default CSSModules(
  SimpleRadioButton,
  styles,
  { allowMultiple: true },
);
